<template>
    <b-card>
      <div class="alert alert-success" role="alert" style="margin-bottom:0px;" v-if="managers.length > 0">
        Managers for current lock
      </div>
      <b-row>
        <div class="col-sm-6 col-md-3" style="margin-top:5px;margin-bottom:5px;" v-for="manager in managers" :key="manager.id">
          <div class="card" style="height:100%;">
            <div class="card-body" style="height:10px;padding-top: 0px;">
              <div class="h1 text-muted text-right mb-4" style="display: flex; justify-content: center; align-items: center; ">
                <strong v-if="!manager.managedBy.avatar == ''">
                  <img class="img-avatar" :src="manager.managedBy.avatar" :alt="manager.managedBy.email" style="margin:10px; height:35px;">
                </strong>
                <strong v-if="manager.managedBy.avatar == ''">
                  <i class="icon-user navbar" v-if="manager.managedBy.gender == 'male'"></i>
                  <i class="icon-user-female navbar" v-if="manager.managedBy.gender == 'female'"></i>
                </strong>
              </div>

            </div>
            <div style="margin-left: 10px;margin-bottom: 10px;">
              <small class="text-muted text-uppercase font-weight-bold" v-if="(manager.managedBy.gender == null || manager.managedBy.gender == 'male')"><i class="icon-user"></i> : {{manager.managedBy.name}}<br/></small>
              <small class="text-muted text-uppercase font-weight-bold" v-if="(manager.managedBy.gender == 'female')"><i class="icon-user-female" ></i> : {{manager.managedBy.name}}<br/></small>
              <small class="text-muted text-uppercase font-weight-bold"><i class="icon-phone"></i> : {{manager.managedBy.phone}} <a :href="whatsapp(manager.managedBy.phone)" :target="manager.managedBy.phone"><i class="fa fa-whatsapp"></i></a> <br/></small>
              <small class="text-muted text-uppercase font-weight-bold"><i class="icon-calendar"></i> : {{(new Date(manager.startDate)).toLocaleString('en-GB',{day: 'numeric',  month: 'short',  year: 'numeric'})}} until<br/></small>
              <small class="text-muted text-uppercase font-weight-bold"><i class="icon-calendar"></i> : {{(new Date(manager.endDate)).toLocaleString('en-GB',{day: 'numeric',  month: 'short',  year: 'numeric'})}}<br/></small>
              <small class="text-muted text-uppercase font-weight-bold"><i class="icon-envelope"></i> : <a :href="mailto(manager.managedBy.email)">Click Here</a><br/></small>
            </div>
            <b-button type="button" variant="danger" v-on:click="removeManager(manager.id)" style="margin:  10px;float:left;">
              <i class="fa fa-trash-o"></i> Remove
            </b-button>
          </div>
        </div>

      </b-row>

      <div class="alert alert-success" role="alert" style="margin-bottom:0px; width=100%;" v-if="availableManagers.length > 0">
        Please select manager below
      </div>
      <b-row>
        <!-- list available manager -->
        <div class="col-sm-6 col-md-3" style="margin-top:10px;" v-for="manager in availableManagers" :key="manager.id">
          <div class="card" style="height:100%;">
            <div class="card-body" style="height: 10px;padding-top: 0px;">

              <div class="h1 text-muted text-right mb-4" style="display: flex; justify-content: center; align-items: center; ">
                <strong v-if="!manager.managedBy.avatar == ''">
                  <img class="img-avatar" :src="manager.managedBy.avatar" :alt="manager.managedBy.email" style="margin:10px; height:35px;">
                </strong>
                <strong v-if="!manager.managedBy.avatar">
                  <i class="icon-user navbar" v-if="manager.managedBy.gender == 'male'"></i>
                  <i class="icon-user-female navbar" v-if="manager.managedBy.gender == 'female'"></i>
                </strong>
              </div>

            </div>
            <div style="margin-left: 10px;margin-bottom: 10px;">

              <small class="text-muted text-uppercase font-weight-bold" v-if="(manager.managedBy.gender == null || manager.managedBy.gender == 'male')"><i class="icon-user"></i> : {{manager.managedBy.name}}<br/></small>
              <small class="text-muted text-uppercase font-weight-bold" v-if="(manager.managedBy.gender == 'female')"><i class="icon-user-female" ></i> : {{manager.managedBy.name}}<br/></small>
              <small class="text-muted text-uppercase font-weight-bold"><i class="icon-phone"></i> : {{manager.managedBy.phone}} <a :href="whatsapp(manager.managedBy.phone)" :target="manager.managedBy.phone"><i class="fa fa-whatsapp"></i></a><br/></small>
              <small class="text-muted text-uppercase font-weight-bold"><i class="icon-calendar"></i> : {{(new Date(manager.startDate)).toLocaleString('en-GB',{day: 'numeric',  month: 'short',  year: 'numeric'})}} until<br/></small>
              <small class="text-muted text-uppercase font-weight-bold"><i class="icon-calendar"></i> : {{(new Date(manager.endDate)).toLocaleString('en-GB',{day: 'numeric',  month: 'short',  year: 'numeric'})}}<br/></small>
              <small class="text-muted text-uppercase font-weight-bold"><i class="icon-envelope"></i> : <a :href="mailto(manager.managedBy.email)">Click Here</a><br/></small>
            </div>
            <b-button type="button" variant="primary" v-on:click="addManagerToLock(manager.id)" style="margin:  10px;float:left;">
              <i class="fa fa-plus-circle"></i> Add
            </b-button>
          </div>
        </div>
      </b-row>

    </b-card>
</template>

<script>
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/lockManagers/listForLock'
const API_ADD_MANAGER_TO_LOCK = BASE + '/api/lockManagerMappers/addLock'
const API_DELETE_MANAGER_TO_LOCK = BASE + '/api/lockManagerMappers/delete'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function getData (lockId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockId: lockId,
    available: false
  }
  let res = await postdata(API, parameters)
  return res
}

async function postManagerToLock (managerId, lockId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockManagerId: managerId,
    lockId: lockId
  }
  let res = await postdata(API_ADD_MANAGER_TO_LOCK, parameters)
  return res.lockManagers
}
async function removeManagerFromLock (managerId, lockId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockManagerId: managerId,
    lockId: lockId
  }
  let res = await postdata(API_DELETE_MANAGER_TO_LOCK, parameters)
  return res
}

export default {
  name: 'manager-list-for-lock',
  props: ['locationName', 'locationDescription'],
  data: () => {
    return {
      managers: [],
      availableManagers: [],
      fields: {
        name: {
          label: '<i class="icon-user progress-group-icon"></i>'
        },
        phone: {
          label: '<i class="icon-phone"></i>'
        },
        email: {
          label: '@'
        },
        action: {
          label: '<i class="icon-menu"></i>'
        }
      },
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
      filter: null
    }
  },
  mounted () {
    getData(this.$route.params.lockId).then(response => {
      this.$data.managers = response.lockManagers
      this.$data.availableManagers = response.availableManagers
    })
  },
  methods: {
    mailto (email) {
      return 'mailto:' + email
    },
    getRowCount (items) {
      return items.length
    },
    openlink (link) {
      location.href = link
    },
    addManagerToLock (managerId) {
      postManagerToLock(managerId, this.$route.params.lockId).then(response => {
        getData(this.$route.params.lockId).then(response => {
          this.$data.managers = response.lockManagers
          this.$data.availableManagers = response.availableManagers
        })
      })
    },
    removeManager (managerId) {
      removeManagerFromLock(managerId, this.$route.params.lockId).then(response => {
        getData(this.$route.params.lockId).then(response => {
          this.$data.managers = response.lockManagers
          this.$data.availableManagers = response.availableManagers
        })
      })
    },
    whatsapp (phone) {
      let phoneNoPlus = phone.slice(1)
      return 'https://api.whatsapp.com/send?phone=' + phoneNoPlus
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/ManagerListForLock.vue